module.exports = __webpack_public_path__ + "img/logo-large.6466e453.png";